import React from "react";

const CseSem5MDU = () => {
  return (
    <>
      <div style={{ backgroundColor: "#Dbe6ea" }}>
        <h1 class="mb-1">
          SEMESTER 5 <br />
          Select Your Subject
          <div class="spinner-grow text-primary" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </h1>
      </div>
      <div class="accordion" id="accordionExample">
        <div class="accordion-item">
          <h2 class="accordion-header" id="headingOne">
            <button
              class="accordion-button"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseOne"
              aria-expanded="true"
              aria-controls="collapseOne"
            >
              Theory Of Automata
            </button>
          </h2>
          <div
            id="collapseOne"
            class="accordion-collapse collapse show"
            aria-labelledby="headingOne"
            data-bs-parent="#accordionExample"
          >
            <div class="accordion-body" id="sub">
              <a
                href="https://drive.google.com/file/d/1Gsj_4c25plDv2H0MTsPcn5An_PqThK-u/view?usp=sharing"
                target="_blank"
                rel="noreferrer"
              >
                <button type="button" class="btn btn-primary">
                  2013
                </button>
              </a>
              <br />
              <a
                href="https://drive.google.com/file/d/10AvsdAUjp6YZFgX98P46UGJo5NZy1IKw/view?usp=sharing"
                target="_blank"
                rel="noreferrer"
              >
                <button type="button" class="btn btn-primary">
                  2014
                </button>
              </a>
              <br />
              <a
                href="https://drive.google.com/file/d/1Xnd30iNt7w-G0Msq1FgGYerEDw2oPZyf/view?usp=sharing"
                target="_blank"
                rel="noreferrer"
              >
                <button type="button" class="btn btn-primary">
                  2015
                </button>
              </a>
              <br />
              <a
                href="https://drive.google.com/file/d/1qEh1f7DXMwaiNkA58IemoSOb1sxqF8bI/view?usp=sharing"
                target="_blank"
                rel="noreferrer"
              >
                <button type="button" class="btn btn-primary">
                  2016
                </button>
              </a>
              <br />
              <a
                href="https://drive.google.com/file/d/1vvfQ_NvkhfpCevZfEv767jCcscjDyZxd/view?usp=sharing"
                target="_blank"
                rel="noreferrer"
              >
                <button type="button" class="btn btn-primary">
                  2017
                </button>
              </a>
              <br />
              <a
                href="https://drive.google.com/file/d/1V6siHjaTqwIUnlA4Oi5o6I5v7fLeWgxv/view?usp=sharing"
                target="_blank"
                rel="noreferrer"
              >
                <button type="button" class="btn btn-primary">
                  2018
                </button>
              </a>
              <br />
            </div>
          </div>
        </div>
        <div class="accordion-item">
          <h2 class="accordion-header" id="headingTwo">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseTwo"
              aria-expanded="false"
              aria-controls="collapseTwo"
            >
              Web Development
            </button>
          </h2>
          <div
            id="collapseTwo"
            class="accordion-collapse collapse"
            aria-labelledby="headingTwo"
            data-bs-parent="#accordionExample"
          >
            <div class="accordion-body" id="sub">
              <a
                href="https://drive.google.com/drive/folders/187q9ilVV59uIrOP30XedxueZiZF8Zopo?usp=sharing"
                target="_blank"
                rel="noreferrer"
              >
                <button type="button" class="btn btn-primary">
                  2013
                </button>
              </a>
              <br />
              <a
                href="https://drive.google.com/file/d/1_y6_Olhpfy5eV9muXqrj-JBmvbLDnUYF/view?usp=sharing"
                target="_blank"
                rel="noreferrer"
              >
                <button type="button" class="btn btn-primary">
                  2014
                </button>
              </a>
              <br />
              <a
                href="https://drive.google.com/file/d/1c6_cm9DTcCdUxlTBUJ31BwcsWYs6Eeng/view?usp=sharing"
                target="_blank"
                rel="noreferrer"
              >
                <button type="button" class="btn btn-primary">
                  2016
                </button>
              </a>
              <br />
              <a
                href="https://drive.google.com/file/d/1fhnK9lPeh9PS-dh8k3zMCEF0V6o-LID1/view?usp=sharing"
                target="_blank"
                rel="noreferrer"
              >
                <button type="button" class="btn btn-primary">
                  2017
                </button>
              </a>
              <br />
              <a
                href="https://drive.google.com/file/d/1DACygN12Ms_YIDTfPAlnbYE5P4zQH5-q/view?usp=sharing"
                target="_blank"
                rel="noreferrer"
              >
                <button type="button" class="btn btn-primary">
                  2018
                </button>
              </a>
              <br />
            </div>
          </div>
        </div>
        <div class="accordion-item">
          <h2 class="accordion-header" id="headingThree">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseThree"
              aria-expanded="false"
              aria-controls="collapseThree"
            >
              Operating System
            </button>
          </h2>
          <div
            id="collapseThree"
            class="accordion-collapse collapse"
            aria-labelledby="headingThree"
            data-bs-parent="#accordionExample"
          >
            <div class="accordion-body" id="sub">
              <a
                href="https://drive.google.com/file/d/1mN3EgntLxYnMBIIq8eoEmYCArY5hDzPp/view?usp=sharing"
                target="_blank"
                rel="noreferrer"
              >
                <button type="button" class="btn btn-primary">
                  2014
                </button>
              </a>
              <br />
              <a
                href="https://drive.google.com/file/d/1bKI7lxELUsApfnCm9k9hu2hhH-wB9JD7/view?usp=sharing"
                target="_blank"
                rel="noreferrer"
              >
                <button type="button" class="btn btn-primary">
                  2016
                </button>
              </a>
              <br />
              <a
                href="https://drive.google.com/file/d/10L8UzzGaVpnJrf0-NZAXy51CurLaMejV/view?usp=sharing"
                target="_blank"
                rel="noreferrer"
              >
                <button type="button" class="btn btn-primary">
                  2017
                </button>
              </a>
              <br />
              <a
                href="https://drive.google.com/file/d/1QiddCKp_r3lX0OlGXmy-uiAWvymHGTFY/view?usp=sharing"
                target="_blank"
                rel="noreferrer"
              >
                <button type="button" class="btn btn-primary">
                  2018
                </button>
              </a>
              <br />
            </div>
          </div>
        </div>
        <div class="accordion-item">
          <h2 class="accordion-header" id="headingFour">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseFour"
              aria-expanded="false"
              aria-controls="collapseFour"
            >
              Computer Graphics
            </button>
          </h2>
          <div
            id="collapseFour"
            class="accordion-collapse collapse"
            aria-labelledby="headingFour"
            data-bs-parent="#accordionExample"
          >
            <div class="accordion-body" id="sub">
              <a
                href="https://drive.google.com/file/d/1BRMpNGnYU2ujdYvyg_CSGyalRlIYclFg/view?usp=sharing"
                target="_blank"
                rel="noreferrer"
              >
                <button type="button" class="btn btn-primary">
                  2015
                </button>
              </a>
              <br />
              <a
                href="https://drive.google.com/file/d/11xTEpPbczWF3npQP_yA9C_czGicnQp2q/view?usp=sharing"
                target="_blank"
                rel="noreferrer"
              >
                <button type="button" class="btn btn-primary">
                  2016
                </button>
              </a>
              <br />
              <a
                href="https://drive.google.com/file/d/1ehwDeQRPgYXAg3JtsqLCpZSU48WxOYC2/view?usp=sharing"
                target="_blank"
                rel="noreferrer"
              >
                <button type="button" class="btn btn-primary">
                  2017
                </button>
              </a>
              <br />
              <a
                href="https://drive.google.com/file/d/1ZGECdhUGBVlMtJ4IcYhKYTx4jZIxAdYb/view?usp=sharing"
                target="_blank"
                rel="noreferrer"
              >
                <button type="button" class="btn btn-primary">
                  2018
                </button>
              </a>
              <br />
            </div>
          </div>
        </div>
        <div class="accordion-item">
          <h2 class="accordion-header" id="headingFive">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseFive"
              aria-expanded="false"
              aria-controls="collapseFive"
            >
              Microprocessor
            </button>
          </h2>
          <div
            id="collapseFive"
            class="accordion-collapse collapse"
            aria-labelledby="headingFive"
            data-bs-parent="#accordionExample"
          >
            <div class="accordion-body" id="sub">
              <a
                href="https://drive.google.com/file/d/1Q3NPyJcTF4dC6xWzYdj-RALC8CEMGK2m/view?usp=sharing"
                target="_blank"
                rel="noreferrer"
              >
                <button type="button" class="btn btn-primary">
                  2014
                </button>
              </a>
              <br />
              <a
                href="https://drive.google.com/file/d/15YM-wdzBJP48Qc3FU7vvadCXTpInPE5z/view?usp=sharing"
                target="_blank"
                rel="noreferrer"
              >
                <button type="button" class="btn btn-primary">
                  2015
                </button>
              </a>
              <br />
              <a
                href="https://drive.google.com/file/d/149chtEJIk5BVTVCv15RiF3QuwQU54f5C/view?usp=sharing"
                target="_blank"
                rel="noreferrer"
              >
                <button type="button" class="btn btn-primary">
                  2016
                </button>
              </a>
              <br />
              <a
                href="https://drive.google.com/file/d/1k8pjiV9UHoI1XD2PBmQvUI_6YYQSorQ-/view?usp=sharing"
                target="_blank"
                rel="noreferrer"
              >
                <button type="button" class="btn btn-primary">
                  2017
                </button>
              </a>
              <br />
              <a
                href="https://drive.google.com/file/d/1bO9vs0vNloh-2lOAYAHGw_nrQHEbx-q6/view?usp=sharing"
                target="_blank"
                rel="noreferrer"
              >
                <button type="button" class="btn btn-primary">
                  2018
                </button>
              </a>
              <br />
              <a
                href="https://drive.google.com/file/d/1oN1XMK7VjTqq_JKViWl1d6utr83570AS/view?usp=sharing"
                target="_blank"
                rel="noreferrer"
              >
                <button type="button" class="btn btn-primary">
                  2019
                </button>
              </a>
              <br />
              <a
                href="https://drive.google.com/file/d/1h1bY7GTER64gaxhpgs8A8Sja5Rtr6f27/view?usp=sharing"
                target="_blank"
                rel="noreferrer"
              >
                <button type="button" class="btn btn-primary">
                  2021
                </button>
              </a>
              <br />
            </div>
          </div>
        </div>
        <div class="accordion-item">
          <h2 class="accordion-header" id="headingSix">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseSix"
              aria-expanded="false"
              aria-controls="collapseSix"
            >
              Multimedia Technology
            </button>
          </h2>
          <div
            id="collapseSix"
            class="accordion-collapse collapse"
            aria-labelledby="headingSix"
            data-bs-parent="#accordionExample"
          >
            <div class="accordion-body" id="sub">
              <a
                href="https://drive.google.com/file/d/1lRYAIVVnfIPJLAH8m0-CMzkNF75dCPzW/view?usp=sharing"
                target="_blank"
                rel="noreferrer"
              >
                <button type="button" class="btn btn-primary">
                  2013
                </button>
              </a>
              <br />
              <a
                href="https://drive.google.com/file/d/1W5ICHs79DmQC7lKB7jP-BzJLVi8LJmdH/view?usp=sharing"
                target="_blank"
                rel="noreferrer"
              >
                <button type="button" class="btn btn-primary">
                  2014
                </button>
              </a>
              <br />
              <a
                href="https://drive.google.com/file/d/19UfmdDGWIp3_jGFSYgZWwC8keDNPiJua/view?usp=sharing"
                target="_blank"
                rel="noreferrer"
              >
                <button type="button" class="btn btn-primary">
                  2015
                </button>
              </a>
              <br />
              <a
                href="https://drive.google.com/file/d/12tfUJELq2qsc8G2K6R-XyLAPJ4jASJVP/view?usp=sharing"
                target="_blank"
                rel="noreferrer"
              >
                <button type="button" class="btn btn-primary">
                  2017
                </button>
              </a>
              <br />
              <a
                href="https://drive.google.com/file/d/1ItfIFGofKDUWC15TycGz2CZqDS_a683p/view?usp=sharing"
                target="_blank"
                rel="noreferrer"
              >
                <button type="button" class="btn btn-primary">
                  2018
                </button>
              </a>
              <br />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CseSem5MDU;
